module.exports = __webpack_public_path__ + "static/media/012-line-purple.8c8a810d.svg";